// extracted by mini-css-extract-plugin
export var active = "_im-2";
export var recordingDot = "_im-1";
export var recordingIndicator = "_im-0";